window.contactmoment = {}

window.contactmoment.filterContactmoment = (data) => {
  data.status = 20;
  return data
}

window.contactmoment.validateContactmoment = (data, asHTMLList = false) => {

  const errors = []

  const addError = (selector, message) => {
    errors.push({
      selector,
      message,
    })
  }

  if (data.omschrijving.length === 0) {
    addError('omschrijving', 'Dit veld is verplicht')
  }

  if (data.omschrijving.length > 100) {
    addError('omschrijving', 'De omschrijving mag maximaal 100 tekens bevatten')
  }

  if (data.hasOwnProperty('tijdsduur') && data.tijdsduur != ''
    && data.hasOwnProperty('tijdsduurInterval') && data.tijdsduurInterval != '' && data.tijdsduurInterval > 0) {

    if ( (parseInt(data.tijdsduur) % parseInt(data.tijdsduurInterval)) !== 0) {
      addError('tijdsduur', 'De tijdsduur dient per '+data.tijdsduurInterval+' minuten te worden opgegeven.')
    }
  }

  if (asHTMLList) {
    if (!errors.length) {
      return ''
    }
    const uniqueErrors = [...new Set(errors.map((error) => error.message))]
    return uniqueErrors.reduce((acc, cur) => {
      acc += '<li>' + cur + '</li>'
      return acc
    },'<ul>') + '</ul>'
  }

  return errors
}
